// extracted by mini-css-extract-plugin
module.exports = {"paper":"ScientificResearchTable_paper__3utz8"};